import { Address } from "@data/schema/loan-appication/address";
import { Income } from "@data/schema/loan-appication/income";
import {EmploymentIncome} from '@data/schema/loan-appication/employment-income';

export class Employment {
  sEmploymentType: string;
  sName: string;
  sPhone: string;
  sStartDate: Date;
  sPosition: string;
  sEmail: string;
  sTimeInLineOfWork: number;
  sAddress: Address;
  sFax: string;
  sSelfEmployedFlag: boolean;
  sIsPrimaryEmploymentFlag: boolean;
  sSpecialBorrowerEmployerRelationShipType: string;
  sHRName: string;
  sHRTitle: string;
  sEmployeeCode: string;
  sHREmail: string;
  sHRContact: string;
  sSalaryKey: string;
  sIncomes: EmploymentIncome;
}
